export default {
  chargebackAlert: {
    // 搜索条件相关
    searchIds: '综合查询',
    searchIdsPlaceholder: '预警ID、源交易流水号、商户订单号',
    alertService: '预警服务',
    alertType: '预警类型',
    chargebackStatus: '源交易拒付状态',
    refundType: '源交易退款类型',
    receivedTime: '预警接收时间',

    // 表格字段相关 - 作者：Nemo
    preDisputeId: '预警ID',
    service: '预警服务',
    type: '预警类型',
    createdTime: '预警发起时间',
    txnId: '源交易流水号',
    merchantOrderNumber: '商户订单号',
    txnAmount: '源交易金额',
    refundStatus: '源交易退款类型',
    dueIn: '处理时间剩余',
    viewDetail: '详情',
    refund: '退款',
    viewTransactionDetail: '查看源交易',

    // 状态选项
    disputed: '有拒付',
    noChargeback: '无拒付',
    partiallyRefunded: '部分退款',
    fullyRefunded: '全额退款',
    notRefunded: '无退款',

    // 详情页相关
    alertInfo: '预警信息',
    alertDetails: '预警详情',
    alertDescription: '预警描述',
    recommendations: '建议',
    processInfo: '处理信息',
    processReason: '处理原因',
    markAsProcessed: '标记为已处理',
    markAsIgnored: '标记为忽略',

    // 详情页顶部区域
    preDisputeAmount: '预警金额',
    transactionAmount: '源交易金额',

    // Pre-dispute details模块
    preDisputeDetails: '拒付预警信息',
    amount: '金额',
    currency: '币种',
    source: '发起方',
    reasonCode: '发起原因',

    // Transaction details模块
    transactionDetails: '源交易信息',
    paymentMethod: '支付方式',
    chargebackId: '拒付流水号',
    refundRecords: '退款记录',
    eci: 'ECI',
    website: '交易网址',
    emailBilling: '用户邮箱',
    view: '查看',

    // 其他
    titleTip: '拒付预警提示',
    alertDetail: '预警详情',
    refundId: '退款流水号',

    // 表头提示信息 - 作者：Nemo
    dueInTooltip: '系统将在接收预警24小时后自动退款。',

    // 批量退款相关 - 作者：Nemo
    batchRefund: '批量退款',
    batchRefundCaution: '注意：你正在进行批量退款。针对已部分退款的交易，剩余可退部分将被提交退款。',
    preDisputesSelected: '条拒付预警被选中，其中：',
    batchPartiallyRefunded: '已部分退款',
    batchNoYetRefunded: '无退款',
    batchRefundNote: '针对已部分退款的交易，剩余可退部分将被提交退款。',
    pleaseSelectData: '请先选择要操作的数据',
    autoRefundInitiated: '自动退款已提交',
    autoRefundInitiatedAt: '自动退款已提交于',

    // 详情页专用文案 - 去掉"预警"字样 - 作者：Nemo
    detail: {
      id: 'ID',
      service: '服务',
      type: '类型',
      createdTime: '发起时间',
      receivedTime: '接收时间',
      amount: '金额',
      disputeDetails: '拒付预警信息',
      // 源交易信息专用文案
      txnId: '流水号',
      merchantOrderNumber: '商户订单号',
      txnTime: '交易时间',
      currency: '币种',
      paymentMethod: '支付方式',
      chargebackStatus: '拒付状态',
      chargebackId: '拒付流水号',
      refundStatus: '退款类型',
      refundRecords: '退款记录',
      refundId: '退款流水号',
      eci: 'ECI',
      website: '交易网址',
      emailBilling: '用户邮箱',
    },
  },
};
